module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB2001-036373ea7b9da423284722b2e476995c.png";